/**
 * The single error type this package throws.
 *
 * It carries a code and typed parameters, survives a JSON round trip with its
 * meaning attached (the API's exception filter serialises it; a worker
 * deserialises it), and never contains user-facing prose.
 */
import { isErrorCode } from "./codes.js";
export class AccountingError extends Error {
    code;
    params;
    constructor(code, params) {
        // The message is for logs and stack traces only. Translate from `code`
        // for anything a person reads.
        super(`${code} ${JSON.stringify(params)}`);
        this.name = "AccountingError";
        this.code = code;
        this.params = params;
    }
    toJSON() {
        return { code: this.code, params: this.params };
    }
}
/** Throw with the parameters the code requires. Returns `never`, so it closes a switch. */
export function raise(code, params) {
    throw new AccountingError(code, params);
}
export function isAccountingError(value) {
    return value instanceof AccountingError;
}
/** Narrow to one code, for a caller that handles a specific refusal. */
export function hasErrorCode(value, code) {
    return isAccountingError(value) && value.code === code;
}
/**
 * Rebuild an error that crossed a process boundary. An unknown code is
 * refused rather than passed through, so a version skew between API and
 * worker surfaces as an explicit failure instead of an error nobody can read.
 */
export function accountingErrorFromJson(value) {
    if (!isErrorCode(value.code)) {
        throw new TypeError(`unknown accounting error code: ${value.code}`);
    }
    return new AccountingError(value.code, value.params);
}
//# sourceMappingURL=accounting-error.js.map